import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.ballDeckExitPoint || initialState;

export const selectBallDeckExitPoint = createSelector(
  [selectSlice],
  state => state,
);

export const selectBallDeckExitPointReport = createSelector(
  [selectSlice],
  state => state.ballExitPoint,
);
